<template>
    <div></div>
</template>

<script>
    import { EventBus } from "../../../eventBus";

    export default {
        props: ['route'],
        data: function () {
            return {}
        },
        mounted() {
            axios.post(this.route, {})
                .then((res)=> {
                    EventBus.emit('notificationRead', { unreadNotificationsCount: res.data.unreadNotificationsCount, notificationId: res.data.notificationId, infoMessage: res.data.infoMessage });
                });
        }
    }
</script>